import { createAction, props } from '@ngrx/store';
import { ConsumerType } from '@emm/core/models/consumer-type.model';

export enum ConsumerTypesAction {
    LoadAll = '[Add Consumer Dialog] Load All Consumer Types',
    LoadAllSuccess = '[Menu API] Load All Consumer Types Success',
    LoadAllFailure = '[Menu API] Load All Consumer Types Failure',
}

export const ConsumerTypesActions = {
    loadAll: createAction(ConsumerTypesAction.LoadAll),
    loadAllSuccess: createAction(
        ConsumerTypesAction.LoadAllSuccess,
        props<{ consumerTypes: ConsumerType[] }>()
    ),
    loadAllFailure: createAction(ConsumerTypesAction.LoadAllFailure, props<{ error: any }>())
};

export const ConsumersAsyncActions = {
    loadActions: [ConsumerTypesActions.loadAll],
    successActions: [ConsumerTypesActions.loadAllSuccess],
    errorActions: [ConsumerTypesActions.loadAllFailure]
};
